import React, { useEffect, useState } from 'react';
import { showService } from '../show/showService';
import UpcomingShowsItem from './UpcomingShowsItem';



const UpcomingShows = () => {

    
    const [upcomingShows , setUpcomingShows ] = useState([]);

    const [loading, setLoading] = useState(false);

    function getShowsList() {
        return showService.indexShows({
            sortOrder : "name_desc", 
            searchString : "", 
            pageSize : 5, 
            pageNumber : 1
            })
    }


    async function showList() {

        try{

            setLoading(true);
            const response  = await getShowsList();

            if(response.status === 200) {
    
                setLoading(false);

                setUpcomingShows(response.data.entities);
                // console.log(response.data);
    
            }

        }catch(error){
            setLoading(false);

            console.error(error);
        }

    }

    useEffect(() => {


        showList();


    },[])


    if(loading){
        return <div className='text-center'>Loading...</div>
    }

    return (

        <>
        <h2>Upcoming shows</h2>
    
        <div className='container mt-4'>


            <div className='row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4'>
                {
                    upcomingShows && upcomingShows.map(show => <UpcomingShowsItem  show={show} key={show.id}/>)
                }
            </div>

        </div>
        </>
    );
}

export default UpcomingShows;
